import React, { PureComponent, PropTypes } from 'react';
import Papa from 'papaparse';
import { compareArrayValues, normalizeJaggedDataTable } from '../../services/Utils';
import Input from './input';
import Intro from './intro';
import Preview from './preview';
import Assigner from './assigner';
import { fadein } from '../decorators';
import './importer.css';

class Importer extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {
            data: [],
            ignored: [],
            parseError: null,
            source: '',
            stage: 1
        };
        this.goBack = this.goBack.bind(this);
        this.advance = this.advance.bind(this);
        this.parse = this.parse.bind(this);
        this.onSourceChange = this.onSourceChange.bind(this);
    }

    static propTypes = {
        onComplete: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired
    }

    onSourceChange(source) {
        this.setState({ source });
    }
    advance() {
        this.setState({ stage: Math.min( this.state.stage + 1, 3) });
    }
    goBack() {
        this.setState({ stage: Math.max( this.state.stage - 1, 0) });
    }
    parse() {
        let { source } = this.state;
        let { data: sourceData, errors } = Papa.parse(source);

        if (errors && errors.length > 0) { console.log(errors); }

        let data = sourceData
        .filter(row => row.length > 1)
        .filter((row, index, arr) => arr.findIndex(item => compareArrayValues(item, row)) === index);

        if (data.length > 0) {
            data = normalizeJaggedDataTable(data);
            this.setState({ data, errors, reducedData: [], stage: 2 });
        } else {
            this.setState({ data: [], errors: ["WOOT"], reducedData: []});
        }
    }
    render() {
        let { onCancel, onComplete } = this.props;
        let { data, source, stage } = this.state;

        return (<div className="importer">
            { stage === 0 ? <Intro onCancel={ onCancel } onStart={ this.advance } /> : null }
            { stage === 1 ? <Input content={source} onBack={ this.goBack } onCancel={ onCancel } onComplete={ this.parse } onContentChange={ this.onSourceChange } /> : null }
            { stage === 2 ? <Preview data={ data } onBack={ this.goBack } onCancel={ onCancel } onComplete={ this.advance } /> : null }
            { stage === 3 ? <Assigner data={ data } onBack={ this.goBack } onCancel={ onCancel } onComplete={ onComplete } /> : null }
        </div>);
    }
}

export default fadein(Importer);


// WEBPACK FOOTER //
// ./src/components/importer/index.js